<script>
    import {goToReferalPage} from "@songfinch/customer/composables/useReferralPage";
    import {FormAjax, FormButton, FormError} from "@songfinch/shared/plugins/form_ajax/index";
    import analyticsEvent from "@songfinch/shared/helpers/analyticsEvent";
    import {useSongBuilderStore} from "@songfinch/customer/store_v2/useSongBuilderStore";

    export default {
        name: "BsFormContainer",
        components: {FormAjax, FormButton, FormError},
        props: {
            validator: {type: Function, default: null},
            backValidator: {type: Function, default: null},
            backButtonText: {default: "Back", type: String},
            nextButtonText: {default: "Next", type: String},
            nextButtonAttrs: {type: Object, default: () => ({})},
            error: {type: String, default: ""},
            fullHeight: {type: Boolean, default: false}
        },
        emits: ["next", "back", "next-clicked"],
        methods: {
            async goNext() {
                if (await this.validator?.() === false) return false;

                this.$emit("next", true);

                const storeSongBuilder = useSongBuilderStore();
                await storeSongBuilder.saveData();

                analyticsEvent("_sf_songbuildersubmit", {
                    step: this.$route.name
                });

                const nextPage = this.$route.meta.nextPage ? {name: this.$route.meta.nextPage, params: this.$route.params} : {name: "Cart"};

                storeSongBuilder.setLastSongBuildPage(nextPage);
                return this.$router.push(nextPage);
            },
            async goBack() {
                if (await this.backValidator?.() === false) return false;
                this.$emit("back", this.$refs.form?.$el.checkValidity());
                //if doesn't exist temp for home
                if (this.$route.meta.prevPage) {
                    this.$router.push({name: this.$route.meta.prevPage});
                } else {
                    goToReferalPage();
                }
            }
        }
    };
</script>

<template>
    <FormAjax
        ref="form"
        class="bsFormContainer @container"
        :class="{fullHeight}"
        :submit-action="goNext"
    >
        <div class="bsForm @w-full cmsContent">
            <slot/>
        </div>
        <div class="@mt-auto @w-full">
            <slot name="step-tips"/>
            <FormError wrap-class="@mt-0" error-class="text-danger @mt-4"/>
            <div class="@max-w-375 @mx-auto @mb-8 tablet:@mb-10 @flex @gap-5 @pt-4 @w-full">
                <button
                    type="button"
                    class="mkButton beige invertBorder noHoverMob noMinWidth @w-full"
                    data-cy="prev-songbuilder-page"
                    @click.prevent="goBack"
                >
                    {{backButtonText}}
                </button>
                <FormButton
                    wrap-class="@contents"
                    class="mkButton noHoverMob noMinWidth @w-full"
                    data-cy="next-songbuilder-page"
                    v-bind="nextButtonAttrs"
                    @click="$emit('next-clicked')"
                >
                    {{nextButtonText}}
                </FormButton>
            </div>
        </div>
    </FormAjax>
</template>

<style scoped>
    @import "@songfinch/customer/stylesheets/includes/pages/_cms-content.pcss";
    @import "@songfinch/customer/stylesheets/includes/mixins/index.pcss";

    .bsFormContainer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;

        :deep(.form-group) {
            /*extends .l8*/
            @include font(National, 15px, 15px, 500, 0.25px);
            text-transform: uppercase;
        }

        &.fullHeight {
            .bsForm {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
        }
    }
</style>
